export const removeSubstring = (str: string, substring: string) => {
  if (str.startsWith(substring) || str.endsWith("```")) {
    return str.slice(substring.length);
  }
  return str;
};
